var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.645 2.956a6.667 6.667 0 0 1 9.818 8.871l-2.127-3.826h2a5.333 5.333 0 0 0-9.027-3.848zm8.716 10.09a6.666 6.666 0 0 1-9.818-8.871L4.669 8h-2a5.334 5.334 0 0 0 9.027 3.848z"
})));
export { SvgRefresh as ReactComponent };
export default __webpack_public_path__ + "10367f39d17a76551ddfdb6ae6d8658b.svg";